module.exports = __webpack_public_path__ + "img/qr.b8be6f26.svg";